/* "isLocalPart" means first part of the e-mail address only (local-part@domain) */
export const emailAddressIsValid = (email: string, isLocalPart: boolean = false) => {
  // regex from wpbox/static/webapps/altibox/js/altibox/src/validators/validators.js
  const match = isLocalPart ? email.match(/^([a-zA-Z0-9\._-])+$/) : email.match(/^[a-zA-Z0-9._-]+@\w+.\w+/);
  return match !== null;
};

export const emailAccountPasswordLengthIsOk = (password: string) => password.length >= 8;
export const emailAccountPasswordComplexityIsOk = (password: string) => {
  // Need to have three of these four
  const upperCaseRegex = /[A-Z]+/;
  const lowerCaseRegex = /[a-z]+/;
  const numberRegex = /\d+/;
  const specialCaseRegex = /[#?!@$%^&*-]+/;

  const pwComplexityCheck = {
    lowerCase: lowerCaseRegex.test(password),
    upperCase: upperCaseRegex.test(password),
    digits: numberRegex.test(password),
    special: specialCaseRegex.test(password),
  };
  const validRules = Object.entries(pwComplexityCheck).filter((rule) => rule[1]).length;
  return validRules >= 3;
};

export const emailAccountPasswordIsValid = (password: string) =>
  emailAccountPasswordLengthIsOk(password) && emailAccountPasswordComplexityIsOk(password);

export const accesspointNameIsValid = (name: string) => {
  // valid input: ISO 8859-1 (Latin-1), From 0 to 255 characters.

  if (name.length > 255) {
    return false;
  }

  return isValidLatin1Printable(name);
};

const isValidLatin1Printable = (str: string) => {
  /*  Allowing two ranges of printable characters from the ISO 8859-1 (Latin-1) table:
  1) From: \x20 = hex 20 (space) To: \x7E = ~
  2) From: \xA0 = non-breaking space To: \xFF = ÿ
  Everything outside these ranges are not accepted. */

  return /^[\x20-\x7E\xA0-\xFF]*$/.test(str);
};
